import { useMutation } from '@tanstack/react-query';
import {
  VerifyOtpByEmailDto,
  VerifyOtpByEmailEntity,
  UserWalletAuthService,
} from 'services/openapi';

export const useAuthControllerVerifyOtpByEmail = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<VerifyOtpByEmailEntity, Error, VerifyOtpByEmailDto>({
      mutationFn: (variables: VerifyOtpByEmailDto) => {
        return UserWalletAuthService.authControllerVerifyOtpByEmail(variables);
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
